module.exports = __webpack_public_path__ + "img/emerald-orb.c331c647.webp";